import type { ReactNode } from "react";
import { Fragment } from "react";
import { Box } from "../../../../components/box";
import FontFa from "../../../../components/fontFa/fontFa";
import { ApprovedDate } from "./molecule/ApprovedDate";
import { Assignee } from "./molecule/Assignee";
import { AssigneeDate } from "./molecule/AssigneeDate";
import { Content1 } from "./molecule/Content1";
import { Content2 } from "./molecule/Content2";
import { CreatedDate } from "./molecule/CreatedDate";

interface Props<TData> {
  title: ReactNode;
  data: TData[];
  mdHorizontal?: boolean;
  mdSmall?: boolean;
  getStepKey?: (step: TData) => string | number;
  getStepClassName?: (step: TData) => string;
  getStepIcon: (step: TData) => string | number;
  getStepHidden?: (step: TData) => boolean;
  renderContent: (step: TData) => ReactNode;
}

function Progress<TData>(props: Props<TData>) {
  const {
    title = "Quy trình duyệt",
    data,
    mdHorizontal = true,
    mdSmall = true,
    getStepClassName,
    getStepKey,
    getStepIcon,
    getStepHidden,
    renderContent,
  } = props;

  return (
    <Box title={title}>
      <div
        className={`TimelineBox horizontal ${mdHorizontal ? "mdHorizontal" : ""} ${mdSmall ? "mdSmall" : ""}`}
      >
        {data.map((step, index) => {
          const key = getStepKey?.(step) ?? index;
          const stepClassName = getStepClassName?.(step) ?? "";
          const icon = getStepIcon(step);
          const hidden = getStepHidden?.(step) ?? false;
          const content = renderContent(step);
          
          return (
            <Fragment key={key}>
              {hidden ? (
                <></>
              ) : (
                <div className="item">
                  <div className={`step ${stepClassName}`}>{icon && <FontFa name={icon} />}</div>
                  <div className="content">{content}</div>
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </Box>
  );
}

export default Progress;

export { ApprovedDate, Assignee, AssigneeDate, Content1, Content2, CreatedDate };
